module.exports = __webpack_public_path__ + "img/EZD_20240330_1.f2236dcd.jpg";